import React from 'react'

import { Block } from 'common/builder/components/chart/FlowChart/components/Block/Block'
import { NextStep } from 'common/builder/components/chart/FlowChart/components/NextStep/NextStep'
import { ContentNodeHeader } from 'common/builder/components/chart/FlowChart/components/Node/components/ContentNodeHeader/ContentNodeHeader'
import { NodeContainer } from 'common/builder/components/chart/FlowChart/components/Node/components/NodeContainer/NodeContainer'
import { NodeStats } from 'common/builder/components/chart/FlowChart/components/Node/components/NodeStats/NodeStats'
import { EmptyNextStepSpacer } from 'common/builder/components/chart/FlowChart/components/Node/Content/EmptyNextStepSpacer'
import { NodeComponent } from 'common/builder/components/chart/FlowChart/components/Node/types'
import { ButtonStatContextProvider } from 'common/builder/components/chart/FlowChart/contexts/ButtonStatContext'
import { useContentNodeButtonStatProviderValue } from 'common/builder/components/chart/FlowChart/hooks/useContentNodeButtonStatProviderValue'
import { FlowChartContentNode } from 'common/builder/components/chart/FlowChart/types/FlowChartNode/FlowChartContentNode'

export const ContentNode: NodeComponent<FlowChartContentNode> = ({
  container,
  node,
  builderId,
  noStat,
  readonly,
  disableFlowChartInteractions,
}) => {
  const showStats = !noStat && readonly && node.data.stats.statsTable.length > 0
  const buttonStatProviderValue = useContentNodeButtonStatProviderValue()

  return (
    <ButtonStatContextProvider value={buttonStatProviderValue}>
      <NodeContainer
        container={container}
        nodeId={node.id}
        builderId={builderId}
        disableFlowChartInteractions={disableFlowChartInteractions}
      >
        <ContentNodeHeader
          header={node.data.header}
          respondents={node.data.respondents}
          showStats={showStats}
        />
        {showStats && <NodeStats rows={node.data.stats.statsTable} />}
        {node.data.blocks.map((block, index) => (
          <Block block={block} key={block.id} isLast={index === node.data.blocks.length - 1} />
        ))}
        {node.data.nextSteps.map((nextStep) => (
          <NextStep key={nextStep.id} nextStep={nextStep} />
        ))}
        {node.data.nextSteps.length === 0 && <EmptyNextStepSpacer />}
      </NodeContainer>
    </ButtonStatContextProvider>
  )
}
